window.DisclaimerForm = function (scope, disclaimers) {
    var self = this;
    var formName = "disclaimer-form";
    var _protected = BaseForm.call(self, formName, scope);

    self.save = function() {
    };

    self.getJobsName = function() {
        console.warn("Override this function");
    };

    self.onDisclaimerCheckboxChange = function() {
        console.warn("Override this function");
    };

    self.getPreparedData = function() {
        return (self.data.disclaimer_consent);
    };

    self.load = function () {
        self.disclaimers = disclaimers || [];

        for (var i in self.disclaimers) {
            self.disclaimers[i].opend = false;
            self.disclaimers[i].jobsName = self.getJobsName(self.disclaimers[i].applied_job_ids);
            if (i == 0) {
                self.disclaimers[i].opend = true;
            }
        }
    };
};
